import HttpClienteToken from '../../services/HttpClientToken';

import { AutoridadExhortoProps } from '../../interfaces/catalogos/AutoridadExhortoInterface';

export const AutoridadExhorto = () => {

    return new Promise<AutoridadExhortoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/AutoridadExhorto/', token)
            .then( ({ data } : { data : AutoridadExhortoProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerAutoridadExhorto = () => {

    return new Promise<AutoridadExhortoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/AutoridadExhorto/ObtenerAutoridadExhorto', token)
            .then( ({ data } : { data : AutoridadExhortoProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarAutoridadExhorto = ( params: AutoridadExhortoProps ) => {

    return new Promise<AutoridadExhortoProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/AutoridadExhorto/Actualizar', params, token)
            .then( ({ data } : { data : AutoridadExhortoProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idAutoridadExhorto: 0,                 
                    descripcion: '',
                    activo: false,     
                });
            });
        }

    });

}

export const AgregarAutoridadExhorto = ( params: AutoridadExhortoProps ) => {

    return new Promise<AutoridadExhortoProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/AutoridadExhorto/Agregar', params, token)
            .then( ({ data } : { data : AutoridadExhortoProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idAutoridadExhorto: 0,                 
                    descripcion: '',
                    activo: false,    
                });
            });
        }

    });

}